import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TemplateFormValues } from "pages/slots/slotsTemplates/types";
import { WorkzoneType } from "sagas/types/regions";
import { SlotTemplatesDetailType } from "sagas/types/slotTemplates";
import { RootState } from "store";
import { SlotsTemplateStateType } from "./types/slotTemplateModal";

export const initialState: SlotsTemplateStateType = {
  actualRegion: "",
  workzones: [],
  templateDetail: null,
  launchDate: "",
  fetchingWorkzones: false,
};

const SLICE_NAME = "slotTemplateModal";

export const slotTemplateSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    getWorkzonesFetch: (
      state: SlotsTemplateStateType,
      action: PayloadAction<string>
    ) => {
      state.workzones = [];
      state.fetchingWorkzones = true;
    },
    getWorkzonesError: (state: SlotsTemplateStateType) => {
      state.workzones = [];
      state.fetchingWorkzones = false;
    },
    getWorkzonesSuccess: (
      state: SlotsTemplateStateType,
      action: PayloadAction<WorkzoneType[]>
    ) => {
      const { payload } = action;
      state.workzones = payload;
      state.fetchingWorkzones = false;
    },
    resetWorkzones: (state: SlotsTemplateStateType) => {
      state.workzones = [];
    },
    setActualRegion: (
      state: SlotsTemplateStateType,
      action: PayloadAction<string>
    ) => {
      state.actualRegion = action.payload;
    },
    getDetailTemplateRequest: (
      state: SlotsTemplateStateType,
      action: PayloadAction<number>
    ) => {},
    getDetailTemplateError: () => {},
    getDetailTemplateSuccess: (
      state: SlotsTemplateStateType,
      action: PayloadAction<SlotTemplatesDetailType>
    ) => {
      const { payload } = action;
      state.templateDetail = payload;
    },
    createTemplateRequest: (
      state: SlotsTemplateStateType,
      action: PayloadAction<TemplateFormValues>
    ) => {},
    createTemplateError: () => {},
    createTemplateSuccess: () => {},
    getTemplateConfigRequest: (state: SlotsTemplateStateType) => {
      state.launchDate = "";
    },
    getTemplateConfigError: () => {},
    getTemplateConfigSuccess: (
      state: SlotsTemplateStateType,
      action: PayloadAction<string>
    ) => {
      state.launchDate = action.payload;
    },
    updateTemplateRequest: (
      state: SlotsTemplateStateType,
      action: PayloadAction<{ body: TemplateFormValues; id: number }>
    ) => {},
    updateTemplateError: () => {},
    updateTemplateSuccess: () => {},
    deleteTemplateRequest: (
      state: SlotsTemplateStateType,
      action: PayloadAction<number>
    ) => {},
    deleteTemplateError: () => {},
    deleteTemplateSuccess: () => {},
  },
});

export const slotTemplateSelector = (state: RootState) =>
  state.slotTemplateModal;

export const actions = slotTemplateSlice.actions;

export default slotTemplateSlice.reducer;
